import { Directive, ElementRef, HostListener, OnInit } from "@angular/core";
import { gsap, Power2 } from 'gsap';
import { EventsService } from "src/app/services/event/event.service";

@Directive({
  selector: '[flipOnClick]'
})
export class FlipOnClickDirective implements OnInit {
  private originalZIndex: string;
  private isFlipped: boolean = false;

  constructor(
    private el: ElementRef,
    private events: EventsService
  ) {
    this.originalZIndex = this.el.nativeElement.style.zIndex;
  }

  ngOnInit(): void {
    this.events.subscribe("events:animation:tile:reverse", () => {
      this.reverseAnimation();
    });
  }

  @HostListener('click') onClick() {
    const tile = this.el.nativeElement;
    if (!this.isFlipped) {

      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const centerX = screenWidth / 2;
      const centerY = screenHeight / 2;
      const currentX = tile.getBoundingClientRect().left + tile.offsetWidth / 2;
      const currentY = tile.getBoundingClientRect().top + tile.offsetHeight / 2;
      const xOffset = centerX - currentX;
      const yOffset = centerY - currentY;
      
      tile.style.zIndex = '9999';
      
      const tween = gsap.timeline();
      tween.to(tile, { duration: 0.2, x: `+=${xOffset}`, y: `+=${yOffset}`, ease: Power2.easeInOut });
      tween.to(tile, { duration: 0.3, delay: 0.15, rotationY: 90, ease: Power2.easeInOut });
    }
  }

  reverseAnimation() {
    this.isFlipped = false;
    const tile = this.el.nativeElement;
    tile.style.zIndex = this.originalZIndex;
    
    const tween = gsap.timeline();
    tween.to(tile, { duration: 0, x: 0, y: 0, ease: Power2.easeInOut });
    tween.to(tile, { duration: 0, rotationY: 0, ease: Power2.easeInOut });
  }
}
